<template>
  <div class="busniessCenterPage">
    <div class="banner">
      <img src="../assets/images/banner1.png" alt="" />
    </div>

    <div class="content_list" v-if="menuList.length > 0">
      <template v-for="item in menuList">

        <div class="item_card" v-if="item.isuse != 0" :key="item.id">
        <div class="box flex-rowl">
          <div class="icon flex-rowc">
            <van-image
              width=".58rem"
              fit="contain"
              :src="item.icon"
            />
          </div>
          <div class="main">
            <div class="fontSize-mainColor-lg">{{ item.funcname }}</div>
            <div
              class="link"
              v-for="itemChild in item.two_authority"
              :key="itemChild.id"
            >
              <p @click="handleGo(item, itemChild, itemChild.pagepath)" v-if="itemChild.isuse != 0">
                {{ itemChild.funcname }} →
              </p>
            </div>
          </div>
        </div>
      </div>
      </template>
      
    </div>
    <van-empty description="暂无操作" v-else />
  </div>
</template>

<script>
import { getMenuAuthOne } from "../api/api";
export default {
  name: "businessCenter",
  data() {
    return {
      menuList: [],
    };
  },
  created() {
    this.getMenuAuthOne();
  },
  methods: {
    getMenuAuthOne() {
      // let roleId = this.$store.state.USERINFO.roleid;
      getMenuAuthOne().then((res) => {
        // if (roleId == 1) {
        //   this.menuList = res;
        // } else {
          
        // }
        this.menuList = this.filterMenu(res);
      });
    },
    // 过滤菜单栏
    filterMenu(menuList) {
      let roleId = this.$store.state.USERINFO.roleid;
      return menuList
        .filter((item) => {
          return item.viewrange.split(",").indexOf(roleId) > -1;
        })
        .map((item) => {
          item = Object.assign({}, item);
          if (item.two_authority) {
            item.two_authority = this.filterMenu(item.two_authority);
          }
          return item;
        });
    },

    handleGo(item, itemChild, path) {
      // 判断是否有操作权限
      let roleId = this.$store.state.USERINFO.roleid;
      if (itemChild.dorange.split(",").indexOf(roleId) == -1) {
        this.$toast("暂无操作权限");
        return;
      }
      if (path) {
        this.$store.commit("setMenuList", itemChild);
        this.$router.push(path);
      } else {
        this.$toast("即将开放");
      }
    },
  },
};
</script>

<style lang="less">
.busniessCenterPage {
  padding-bottom: 140px;
  .content_list {
    padding: 58px 50px;
  }
  .item_card {
    margin-bottom: 57px;
    width: 100%;
    min-height: 450px;
    box-shadow: 0px 0px 0.07rem 0px rgba(84, 79, 90, 0.1),
      0px 0.06rem 0px 0px #6f5d88;
    transform: rotate(180deg);
    border-radius: 30px;
    display: flex;
    align-items: flex-end;
    justify-content: end;
    .box {
      transform: rotate(-180deg);
      height: 100%;
      padding: 55px 58px;
      box-sizing: border-box;
      width: 100%;
      align-items: flex-start;
    }
    .link {
      font-size: 26px;
      margin-top: 75px;
      a {
        color: #444444;
        opacity: 0.85;
      }
    }
    .icon {
      margin-right: 26px;
      margin-top: 10px;
    }
    .fontSize-mainColor-lg {
      line-height: 60px;
    }

    p {
      opacity: 0.7;
      margin-top: 85px;
      &:nth-child(2) {
        margin-top: 70px;
      }
    }
  }
}
</style>